module.exports = __webpack_public_path__ + "img/_close_gray.9b5b1176.svg";